// Authorization
import Auth from '~views/Authorization';
import Login from '~views/Authorization/Login';
import ForgotPassword from '~views/Authorization/ForgotPassword';
import Registration from '~views/Authorization/Registration';
import ConfirmRegistration from '~views/Authorization/ConfirmRegistration';
import SignIn from '@/components/SignIn';
import SignUp from '@/components/SignUp';
import ResetPassword from '@/components/ResetPassword';
import AccountPage from '@/pages/AccountPage';

//Promo
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import DatasetPage from '@/pages/DatasetPage';
import InformationPage from '@/pages/InformationPage';
import ContactPage from '@/pages/ContactPage';

// Dashboard
import Markets from '~views/Dashboard/Markets';
import Portfolio from '~views/Dashboard/Portfolio';
import Configuration from '~views/Dashboard/Configuration';
import Data from '~views/Dashboard/Data';

const Dashboard = () => import('~views/Dashboard');

const routes = {
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        {
            path: '/auth',
            component: Auth,
            redirect: { name: 'auth.login' },
            children: [
                {
                    path: '/login',
                    name: 'auth.login',
                    component: Login,
                },
                {
                    path: '/forgot-password',
                    name: 'auth.forgot',
                    props: true,
                    component: ForgotPassword,
                },
                {
                    path: '/sign-up',
                    name: 'auth.registration',
                    component: Registration,
                },
                {
                    path: '/confirm-registration',
                    props: true,
                    name: 'auth.confirmRegistration',
                    component: ConfirmRegistration,
                },
                {
                    path: '/confirm-password',
                    props: (route) => ({
                        ...route.query,
                        ...route.params,
                    }),
                    name: 'auth.resetPassword',
                    component: ResetPassword,
                },
            ],
        },
        {
            path: '/account',
            name: 'AccountPage',
            component: AccountPage,
            children: [
                {
                    // UserProfile will be rendered inside User's <router-view>
                    // when /user/:id/profile is matched
                    path: 'sign-up',
                    component: SignUp,
                },
                {
                    // UserPosts will be rendered inside User's <router-view>
                    // when /user/:id/posts is matched
                    path: 'sign-in',
                    component: SignIn,
                },
                {
                    // UserPosts will be rendered inside User's <router-view>
                    // when /user/:id/posts is matched
                    path: 'reset-password',
                    component: ResetPassword,
                },
            ],
            meta: {
                title: 'Account Page',
            },
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            redirect: { name: 'dashboard.portfolio' },
            meta: {
                access: {
                    requiresLogin: true,
                    requiredPermissions: ['all'],
                },
            },
            children: [
                {
                    path: '/dashboard/markets',
                    name: 'dashboard.markets',
                    component: Markets,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['all'],
                        },
                    },
                },
                {
                    path: '/dashboard/portfolio',
                    name: 'dashboard.portfolio',
                    component: Portfolio,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['all'],
                        },
                    },
                },
                {
                    path: '/dashboard/data',
                    name: 'dashboard.data',
                    component: Data,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['all'],
                        },
                    },
                },
                {
                    path: '/dashboard/configuration',
                    name: 'dashboard.configuration',
                    component: Configuration,
                    meta: {
                        access: {
                            requiresLogin: true,
                            requiredPermissions: ['all'],
                        },
                    },
                },
            ],
        },
        {
            path: '/',
            name: 'promo',
            component: HomePage,
        },
        // {
        //     path: '/legal-information',
        //     name: 'legal',
        //     component: LegalInformation,
        // },
        // {
        //     path: '/contact',
        //     name: 'contact',
        //     component: Contact,
        // },
        {
            path: '/about',
            name: 'about',
            component: AboutPage,
        },
        {
            path: '/dataset/:id',
            name: 'dataset',
            component: DatasetPage,
        },
        {
            path: '/dataset/*',
            redirect: '/',
        },
        {
            path: '/contact',
            name: 'ContactPage',
            component: ContactPage,
            meta: {
                title: 'Contact Us Page',
            },
        },
        {
            path: '/legal-information',
            name: 'InformationPage',
            component: InformationPage,
            meta: {
                title: 'Legal Informatiion',
            },
        },
    ],
};

export default routes;
